
import React, { useState, useEffect, useContext, useRef } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import { describeStripeRequirements } from "../utils/stripeRequirements";
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { keyActivate } from "../utils/a11y";
import SessionPopup from "../pages/SessionPopup"
import LocationSearch from "./LocationSearch";
import { paidBookingsPaused } from "./stripe/paidBookings";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let { lambda, appname } = window.app

const BusinessProfile = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");
    const [countries, setCountries] = useState('');
    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);
    const [toastType, setToastType] = useState("");// State for dynamic message
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);
    const [files, setFiles] = useState([]);

    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [selectedPlace, setSelectedPlace] = useState('');
    const [addressData, setAddressData] = useState({});
    const [filesData, setFilesData] = useState([]);
    const [disableSaveBtn, setDisableSaveBtn] = useState(false);
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    const [btnLoader, setBtnLoader] = useState(false);
    const [error, setError] = useState('');

    const [image, setImg] = useState('');
    const [bankStatus, setBankStatus] = useState(null);
    const [bankStatusLoading, setBankStatusLoading] = useState(true);
    const [bankLoginLoading, setBankLoginLoading] = useState(false);
    const [bankConnectLoading, setBankConnectLoading] = useState(false);
    // Set when the client arrives here from the topbar menu's "Business Profile"
    // item, which is the "where do I add my bank?" route into this page - the
    // BANK ACCOUNT panel sits in the right column and is easy to skim past, so
    // it gets scrolled to and ringed briefly on arrival.
    const [highlightBank, setHighlightBank] = useState(false);
    const [showBankWhy, setShowBankWhy] = useState(false);
    const bankSectionRef = useRef(null);
    const bankHighlightDone = useRef(false);
    // const [sortDirection, setSortDirection] = useState('asc');

    // let siteConfig = window?.site?.common;
    // let appResourcesUrl = siteConfig?.imageCloudfront;

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const { clientInfo, setClientInfo, searchedFlag, businessData, setBusinessData, setSearchedFlag, isLoading, mapsAPIkey, setIsLoading, userData, setUserData, GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "User Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
        }
    }, [prevRoute]);

    useEffect(() => {
        // getclient()
    }, []);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);


    useEffect(() => {
        setRoute("user")
        //  GetClientDataContext()
        setActiveMenuId("")
        // setActiveMenuObj({
        //     "Client Management": false,
        //     "Contact Management":false,
        //     "Reports": false
        // })
        userActivity();
    }, []);

    useEffect(() => {
        if (toastMessage && toastType && toast[toastType]) {
            toast[toastType](toastMessage, {
                position: "bottom-center",
                // autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage && setToastMessage("");
        }
    }, [toastMessage, toastType]);




    useEffect(() => {

        GetCountries()
    }, []);


    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/signin");
            return;
        }

        // Skip if clientInfo is still empty
        if (!clientInfo?.subscriptionPayment) return;

        if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
            navigate("/signin");
        }
    }, [clientInfo, navigate]);

    // Arrival from the topbar menu's "Business Profile" item: bring the BANK
    // ACCOUNT panel into view and ring it for a few seconds, then let it fade.
    // Guarded by a ref so a re-render can't replay it mid-fade.
    useEffect(() => {
        if (bankHighlightDone.current || state?.highlight !== "bank") return;
        bankHighlightDone.current = true;
        setHighlightBank(true);

        const scrollTimer = setTimeout(() => {
            const node = bankSectionRef.current;
            if (!node) return;
            // On a wide screen the panel is already sitting in the right column,
            // so only scroll when it isn't fully visible - otherwise the page
            // jumps for no reason.
            const rect = node.getBoundingClientRect();
            const fullyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
            if (!fullyVisible) {
                node.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 250);

        const fadeTimer = setTimeout(() => setHighlightBank(false), 4400);

        return () => {
            clearTimeout(scrollTimer);
            clearTimeout(fadeTimer);
        };
    }, [state?.highlight]);


    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state

        setBusinessData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));

    };

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        let presentTime = moment();
        let payload;

        payload = {
            "clientd": localStorage.getItem("clientid"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }

    const handleChange = (event) => {
        const { name, value } = event.target;

        // Check if the field being updated is the phone number
        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = businessData?.idc?.trim(); // Directly get the latest idc value

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }
            setError({ ...error, phone: "" })
            // Update the phone number only
            setBusinessData(prev => ({ ...prev, [name]: formattedValue }));

        } else if (name === "businessname") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setBusinessData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, businessname: "" })

        } else if (name === "emailId") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setBusinessData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, emailId: "" })

        } else {
            // Allow normal updates for other fields
            setBusinessData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the changed field
            }));
        }
    };



    const handleAddressChange = (addressData) => {
        setBusinessData(prevState => ({
            ...prevState,
            businessaddress: addressData.fullAddress || '',
            streetAddress: addressData.address || '',
            city: addressData.city || prevState.city || '',
            state: addressData.state || prevState.state || '',
            zipcode: addressData.zipcode || prevState.zipcode || '',
        }));
        setError((prevError) => ({
            ...prevError,
            businessaddress: "",
        }));
    };
    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });

            const countries = response?.result?.data || [];
            setCountries(countries);
            const usaCountry = countries.filter(
                eachItem => eachItem.countrycode.trim() === "(+1)" && eachItem.alpha2.trim() === "US"
            );

            // Print the filtered country in the console
            console.log("USA Country:", usaCountry);




        } catch {
            console.log("error");
        }
    };
    const handleFileChange = (event) => {
        console.log("event.target.files[0]", event.target.files[0])
        const selectedFile = event.target.files[0];
        // const selectedFilesSize = selectedFile.size; //for single file
        const selectedFiles = Array.from(event.target.files);  //for multiple files

        const allowedFileTypes = ["image/jpeg", "image/png", "image/heic"];
        let fileSize = 1048612 * 5 // 5MB
        if (selectedFile && !allowedFileTypes.includes(selectedFile.type)) {
            setToastMessage("Only JPG, PNG, and HEIC files are allowed!");
            setToastMessage("warning")
            event.target.value = null;
            return;
        } else

            if (selectedFile.size < fileSize) {
                const previewUrl = URL.createObjectURL(selectedFile);
                setBusinessData(prev => ({
                    ...prev,
                    logo: [{ filepath: previewUrl }]
                }));
                setFilesData([selectedFile]); // Store file data

            } else {
                setToastMessage("File size should not exceed 5MB"); // Set the error message
                setToastMessage("warning")
                event.target.value = null;

            }




        // setFiles([...files, ...selectedFiles]); //for multiple files




    };




    const handleUploadSubmit = async () => {
        setBtnLoader(true)
        const ObjectID = require("bson-objectid");
        const uniqueId = new ObjectID().toString();
        // setLocationId(locationId)






        if (filesData && filesData?.length > 0) {
            setDisableSaveBtn(true)
            const uploadPromises = Array.from(filesData).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                // Check the file type
                if (file.type.startsWith('image/')) {
                    // File is an image
                    let filenameReplace = file.name.replace(/ /g, "_")
                    uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                    const data = {
                        source_bucket: bucket, // Use the correct bucket based on file type
                        sourcepath: uploadFilePath
                    };
                    console.log("data", data)
                    const newFile = [{
                        filename: filenameReplace.split('.')[0],
                        filepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    }]
                    const updatedFiles = [...files, ...newFile];
                    console.log("updatedFiles", updatedFiles)
                    setFiles(updatedFiles);

                    const uploadPromise = axios.post(
                        `${lambda}/uploadURL?appname=${appname}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    ).then(async uploadUrlResponse => {
                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const url = uploadUrlResponse.data.result;

                            return axios.put(url, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            }).then(async uploadResponse => {
                                if (uploadResponse.status === 200) {
                                    // setFiles([...files, ...newFile]); 
                                    // handleSubmit(updatedFiles);

                                    handleUpdate(updatedFiles);


                                } else {
                                    throw new Error('Failed to upload file to S3');
                                }
                            });
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    });


                }


            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        } else {
            // handleSubmit([], uniqueId);




            handleUpdate([]);



        }



    }
    const getclient = async (e) => {
        GetTimeActivity(); // Ensure this function is defined elsewhere

        const token = localStorage.getItem("token");


        try {
            const response = await tmdbApi.getClientInfo();

            if (response?.result?.length > 0) {
                setBusinessData(response.result[0]);
                setClientInfo(response.result[0])
            }
        } catch (error) {
            console.error("Error fetching client info:", error);
        }
    };

    const getBankStatus = async () => {
        setBankStatusLoading(true);
        try {
            const response = await tmdbApi.getStripeConnectStatus();
            // Fall back to the same unknown state the catch uses rather than showing
            // "not connected" to a client whose session simply expired.
            setBankStatus(tmdbApi.isSessionExpired(response) ? null : (response?.result || response));
        } catch (error) {
            console.error("Error fetching bank account status:", error);
            setBankStatus(null);
        } finally {
            setBankStatusLoading(false);
        }
    };

    useEffect(() => {
        getBankStatus();
    }, []);

    // Goes straight to Stripe - no intermediate "click to connect" explainer page,
    // the button on this page already *is* that click.
    const handleConnectBank = async () => {
        setBankConnectLoading(true);
        try {
            const response = await tmdbApi.createStripeConnectOnboarding();
            const result = response?.result || response;
            const onboardingUrl = result?.onboardingUrl;

            if (!onboardingUrl) {
                setToastMessage("Could not start bank account setup. Please try again.");
                setToastType("warning");
                setBankConnectLoading(false);
                return;
            }

            // A full-page redirect to Stripe loses React Router state, so stash where
            // we should continue once the client is back (return/refresh pages read this).
            localStorage.setItem("stripeOnboardingNextRoute", "/businessprofile");
            localStorage.setItem("stripeOnboardingMandatory", "");
            window.location.href = onboardingUrl;
        } catch (error) {
            console.error("createStripeConnectOnboarding error:", error);
            setToastMessage("Could not start bank account setup. Please try again.");
            setToastType("warning");
            setBankConnectLoading(false);
        }
    };

    // Once a bank account is already on file, "connecting" again isn't the right
    // action - the client updates/replaces it from Stripe's own Express Dashboard.
    // /stripeConnectLogin mints a single-use login link into that dashboard.
    const handleUpdateBank = async () => {
        setBankLoginLoading(true);
        try {
            // Send the stripeAccountId we already have from stripeConnectStatus - the
            // backend still verifies it matches this client's own record before using it.
            const response = await tmdbApi.getStripeLoginLink({ stripeAccountId: bankStatus?.stripeAccountId });
            const result = response?.result || response;
            const loginUrl = result?.loginUrl || result?.url || result?.dashboardUrl;

            if (!loginUrl) {
                setToastMessage("Could not open the Stripe dashboard. Please try again.");
                setToastType("warning");
                return;
            }

            // A fresh tab so the client doesn't lose their place on this page -
            // the link is single-use/short-lived, meant to be opened once and used.
            window.open(loginUrl, "_blank", "noopener,noreferrer");
        } catch (error) {
            console.error("Error fetching Stripe login link:", error);
            setToastMessage("Could not open the Stripe dashboard. Please try again.");
            setToastType("warning");
        } finally {
            setBankLoginLoading(false);
        }
    };

    // GET /stripeConnectStatus response shape (flat, confirmed against the live endpoint):
    // { stripeAccountId, status, onboardingCompleted, bankConnected, bankName, bankLast4,
    //   bankAccountHolderType, bankStatus, chargesEnabled, payoutsEnabled, detailsSubmitted,
    //   disabledReason, requirementsDue, eventuallyDue, currentDeadline }
    //
    // bankConnected is what gates the button - true the moment a bank account is on file,
    // independent of payoutsEnabled (which can still be false while Stripe verifies an
    // account that already has bank details attached).
    const hasBankAccount = bankStatus?.bankConnected === true;
    const bankRestricted = bankStatus?.status === "RESTRICTED";
    // Payouts still on while Stripe has turned transfers off: the account is RESTRICTED,
    // but "payouts paused" would be the wrong words - what has stopped is paid bookings.
    const paidPaused = paidBookingsPaused(bankStatus);
    // requirementsDue = Stripe has already stopped payouts over these. eventuallyDue =
    // not blocking anything yet, but Stripe will ask once the account crosses a volume
    // threshold and pause payouts if it doesn't get them - so it's worth prompting
    // while everything still works. Both go to the same place: the hosted onboarding
    // link (handleConnectBank), which only asks for what's still outstanding. The
    // threshold amount isn't in the API, so the copy deliberately doesn't quote one.
    const dueLabels = describeStripeRequirements(bankStatus?.requirementsDue);
    const upcomingLabels = bankRestricted ? [] : describeStripeRequirements(bankStatus?.eventuallyDue);

    // Stripe's raw status strings ("new", "validated", "verified", "errored", or our own
    // "CONNECTED"/"RESTRICTED"/"INCOMPLETE"/"NOT_CONNECTED"/"UNKNOWN") aren't sentences -
    // turn them into something presentable.
    const formatStatusLabel = (status) => {
        if (!status) return "";
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase().replace(/_/g, " ");
    };

    // Stripe's requirement keys ("company.tax_id", "external_account", ...) are API
    // identifiers, not sentences - just clean up the punctuation rather than showing them raw.
    const formatRequirement = (key) => {
        const tail = key.split(".").pop() || key;
        return tail.charAt(0).toUpperCase() + tail.slice(1).replace(/_/g, " ");
    };
    const handleUpdate = (filesData) => {
        GetTimeActivity()
        setDisableSaveBtn(true)


        let logoImage = filesData?.[0]?.filepath;



        let payload = {
            businessname: businessData?.businessname ? businessData.businessname.trim() : "",
            idc: businessData?.idc ?? "",
            phone: businessData?.phone ? businessData.phone.trim() : "",
            emailId: businessData?.emailId ? businessData.emailId.trim() : "",
            businessaddress: businessData?.businessaddress ? businessData.businessaddress.trim() : "",
            streetAddress: businessData?.streetAddress ? businessData.streetAddress.trim() : "",
            city: businessData?.city ? businessData.city.trim() : "",
            state: businessData?.state ? businessData.state.trim() : "",
            zipcode: businessData?.zipcode ? businessData.zipcode.trim() : "",
            logo: filesData?.length > 0 ? logoImage : businessData?.logo ?? "",
        };


        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")

        // The API needs the venue's session to change its own account (it ignores the
        // clientid, and every field but the profile ones).
        axios.post(lambda + '/updateClient?appname=' + appname + '&clientid=' + clientInfo?.clientid + '&token=' + token, payload,)
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        setBtnLoader(false)
                        getclient()

                        setIsLoading(false);
                        setToastMessage("Client Details Updated Successfully")
                        setToastType("success")

                    }
                }
            }).catch((err) => {
                setIsLoading(false);
                console.log('errr', err)
            });

        // }
    }
    const handleValidations = () => {
        let formIsValid = true;

        // Safely trim values
        const businessname = businessData?.businessname?.trim() || "";
        const businessaddress = businessData?.businessaddress?.trim() || "";
        const phone = businessData?.phone?.trim() || "";
        const emailId = businessData?.emailId?.trim() || "";
        const idc = businessData?.idc?.trim() || "";

        // Name validation
        if (businessname === "") {
            setError(prev => ({ ...prev, businessname: "Please enter Name" }));
            formIsValid = false;
        } else {
            setError(prev => ({ ...prev, businessname: "" }));
        }

        // Address validation
        if (businessaddress === "") {
            setError(prev => ({ ...prev, businessaddress: "Please enter business address" }));
            formIsValid = false;
        } else {
            setError(prev => ({ ...prev, businessaddress: "" }));
        }

        // Phone validation
        if (phone === "") {
            setError(prev => ({ ...prev, phone: "Please enter phone number" }));
            formIsValid = false;
        } else if (
            (idc === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(phone)) ||
            (idc === "IND" && !/^\d{5}-\d{5}$/.test(phone))
        ) {
            setError(prev => ({ ...prev, phone: "Invalid phone number format" }));
            formIsValid = false;
        } else {
            setError(prev => ({ ...prev, phone: "" }));
        }

        // Email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (emailId === "") {
            setError(prev => ({ ...prev, emailId: "Please enter Email" }));
            formIsValid = false;
        } else if (!emailRegex.test(emailId)) {
            setError(prev => ({ ...prev, emailId: "Please enter a valid Email address" }));
            formIsValid = false;
        } else {
            setError(prev => ({ ...prev, emailId: "" }));
        }

        return formIsValid;
    };

    const handleSave = () => {
        const validate = handleValidations()
        if (validate) {
            handleUploadSubmit()
        }

    }

    const handleRemove = () => {
        // setUploadImg("")
        //setFormData("")
        setFilesData([])
        setBusinessData(prev => ({
            ...prev,
            logo: ""// Clear the logo array
        }));
    }

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Start right Content here  */}

                <div className="main-content user-management" id="businessprofile-main-content">

                    <div className="page-content" id="businessprofile-page-content">
                        <div className="container-fluid" id="businessprofile-container-fluid">

                            <div className="row breadcrumb" id="businessprofile-breadcrumb-row">
                                <div className="col-lg-12" id="businessprofile-breadcrumb-col">
                                    <div className="d-flex align-items-center" id="businessprofile-breadcrumb-align">
                                        <div className="flex-grow-1" id="businessprofile-breadcrumb-flex-grow">
                                            <h4 className="mb-2 card-title" id="businessprofile-title">BUSINESS PROFILE</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="businessprofile-table-data-row">
                                <div className="col-12" id="businessprofile-table-data-col">
                                    <div className="card" id="businessprofile-card">
                                        {/* Bootstrap's real .card is flex-direction:column with .card-body{flex:1 1 auto} -
                                            so card-body stretches to fill any extra height the outer card picks up from its
                                            ancestors, leaving the bank section's short content pinned to the top with a
                                            big blank gap below it before the "Connected" pill. flex:'none' here overrides
                                            that stretch so the card only ever takes the height its own content needs. */}
                                        <div className="card-body Bussiness-Profile" id="businessprofile-card-body" style={{ flex: 'none' }}>

                                            {/* Business Profile Start here */}
                                            {/* alignItems:'flex-start' stops Bootstrap's .row{display:flex} default
                                                (align-items:stretch) from forcing the shorter right column to match the
                                                taller left column's height. */}
                                            <div className="row" id="businessprofile-form-row" style={{ alignItems: 'flex-start' }}>
                                                <div className="col-md-6" id="businessprofile-left-col">

                                                    <div className="input_group_wrapper" id="businessprofile-businessname-wrapper">
                                                        <label className="form_label" htmlFor="businessprofile-businessname-input">
                                                            BUSINESS NAME <span className="required">*</span>
                                                        </label>
                                                        <div className="input_group" id="businessprofile-businessname-input-group">
                                                            <div className="icon_wrapper" id="businessprofile-businessname-icon-wrapper">
                                                                <span className="material-symbols-outlined" id="businessprofile-businessname-icon">storefront</span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Business Name"
                                                                name="businessname"
                                                                id="businessprofile-businessname-input"
                                                                value={businessData?.businessname}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        {error && (
                                                            <span
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                                id="businessprofile-businessname-error"
                                                            >
                                                                {error?.businessname}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <div className="input_group_wrapper mt-3" id="businessprofile-email-wrapper">
                                                        <label className="form_label" htmlFor="businessprofile-email-input">
                                                            BUSINESS EMAIL <span className="required">*</span>
                                                        </label>
                                                        <div className="input_group" id="businessprofile-email-input-group">
                                                            <div className="icon_wrapper" id="businessprofile-email-icon-wrapper">
                                                                <span className="material-symbols-outlined" id="businessprofile-email-icon">mail</span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="businessprofile-email-input"
                                                                name="emailId"
                                                                value={businessData?.emailId}
                                                                placeholder="Email"
                                                                onChange={handleChange}
                                                                // The login email: the API no longer changes it from here
                                                                // (it changed with no verification).
                                                                readOnly
                                                                aria-describedby="businessprofile-email-help"
                                                            />
                                                        </div>
                                                        <span className="form-text text-muted" id="businessprofile-email-help" style={{ fontSize: 12 }}>
                                                            This is your login email. To change it, contact SpotSaver support.
                                                        </span>
                                                        {error && (
                                                            <span
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                                id="businessprofile-email-error"
                                                            >
                                                                {error?.emailId}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <label className="form_label mt-3" htmlFor="businessprofile-phone-input">
                                                        BUSINESS PHONE NUMBER <span className="required">*</span>
                                                    </label>
                                                    <div className="input-group mb-2 mr-sm-2" id="businessprofile-phone-input-group">
                                                        <div className="input-group-prepend" id="businessprofile-phone-prepend">
                                                            <div className="input-group-text" id="businessprofile-phone-prepend-text">
                                                                <span className="material-symbols-outlined" id="businessprofile-phone-icon">call</span>
                                                            </div>
                                                        </div>
                                                        <select
                                                            name="idc"
                                                            className="colorselect capitalize"
                                                            id="businessprofile-country-code-select"
                                                            onChange={handleCountryChange}
                                                            value={businessData?.idc}
                                                        >
                                                            {countries &&
                                                                countries.length > 0 &&
                                                                countries.map((task, i) => (
                                                                    <option key={i} value={task.alpha3} id={`businessprofile-country-option-${i}`}>
                                                                        {task.alpha3}
                                                                        {task.countrycode}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                        <input
                                                            className="form-control"
                                                            name="phone"
                                                            id="businessprofile-phone-input"
                                                            value={businessData?.phone}
                                                            placeholder="Enter Phone Number"
                                                            onChange={handleChange}
                                                        />
                                                        {error && (
                                                            <span
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                                id="businessprofile-phone-error"
                                                            >
                                                                {error?.phone}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <label className="form_label mt-3" htmlFor="businessprofile-address-input">
                                                        BUSINESS ADDRESS <span className="required">*</span>
                                                    </label>
                                                    <div className="input-group mb-2 mr-sm-2" id="businessprofile-address-input-group">
                                                        <div className="input-group-prepend" id="businessprofile-address-prepend">
                                                            <div className="input-group-text" id="businessprofile-address-prepend-text">
                                                                <span className="material-symbols-outlined" id="businessprofile-address-icon">location_on</span>
                                                            </div>
                                                        </div>
                                                        {mapsAPIkey !== false && (
                                                            <LocationSearch
                                                                setSelectedPlace={(place) => {
                                                                    setSelectedPlace(place);
                                                                    handleAddressChange(addressData);
                                                                }}
                                                                setAddressData={(data) => {
                                                                    setAddressData(data);
                                                                    handleAddressChange(data);
                                                                }}
                                                                onChange={(e) => {
                                                                    setBusinessData((prev) => ({ ...prev, businessaddress: e.target.value }));
                                                                    setAddressData({ fullAddress: e.target.value });
                                                                }}
                                                                onBlur={() => handleAddressChange({ fullAddress: businessData?.businessaddress })}
                                                                mapVisible={false}
                                                                formData={businessData}
                                                                mapsAPIkey={mapsAPIkey}
                                                                id="businessprofile-address-input"
                                                            />
                                                        )}
                                                        {error && (
                                                            <span
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                                id="businessprofile-address-error"
                                                            >
                                                                {error?.businessaddress}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <label className="form_label mt-4" htmlFor="businessprofile-logo-upload">
                                                        Upload Logo
                                                    </label>

                                                    <div className="upload-zone input-group mb-2 mr-sm-2" id="businessprofile-logo-upload-zone">
                                                        {businessData?.logo?.length > 0 ?
                                                            <div className="upload-icon mt-1" id="businessprofile-logo-uploaded">
                                                                <div className="img_block add_img_block" id="businessprofile-logo-image-block">
                                                                    <span className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove} onKeyDown={keyActivate(handleRemove)} id="businessprofile-logo-remove-icon">close</span>

                                                                    <img
                                                                        src={
                                                                            Array.isArray(businessData?.logo) && businessData?.logo.length > 0
                                                                                ? businessData?.logo[0]?.filepath
                                                                                : image + businessData?.logo || "" // Fallback to an empty string if no valid image is found
                                                                        }
                                                                        id="activimg"
                                                                    // id="businessprofile-logo-image"
                                                                    />
                                                                    {/* <img id="activimg" src={uploadImg ? uploadImg : "assets/img/store-thumb-img.jpg"} width={150} /> */}
                                                                </div>
                                                            </div> :
                                                            <>

                                                                {/* <div>

                                                                    <input
                                                                        type="file"
                                                                       id="businessprofile-file-upload"
                                                                        accept="image/jpeg, image/png,image/heic,image/jpg"
                                                                        className="d-none"
                                                                        multiple={false}
                                                                        onChange={handleFileChange}
                                                                        style={{ display: 'none' }}
                                                                    />

                                                                    <label
                                                                        htmlFor="file-upload" className="stroke-button"
                                                                        id="businessprofile-file-upload-label">
                                                                        <span className="material-icons" id="businessprofile-file-upload-icon">file_upload</span>
                                                                    </label>
                                                                </div> */}
                                                                <div>
                                                                    <input
                                                                        type="file"
                                                                        id="businessprofile-file-upload"
                                                                        accept="image/jpeg, image/png, image/heic, image/jpg"
                                                                        className="d-none"
                                                                        multiple={false}
                                                                        onChange={handleFileChange}
                                                                        style={{ display: 'none' }}
                                                                    />
                                                                    <label
                                                                        htmlFor="businessprofile-file-upload"
                                                                        className="stroke-button"
                                                                        id="businessprofile-file-upload-label"
                                                                    >
                                                                        <span className="material-icons">file_upload</span>
                                                                    </label>
                                                                </div>

                                                                <div className="file_requirements " id="businessprofile-file-requirements">
                                                                    <p>Maximum file size: 5MB</p>
                                                                    <p>Supported formats: JPG, PNG, HEIC</p>
                                                                </div></>

                                                        }
                                                    </div>

                                                    <button className="fill-btn save_continue" id="businessprofile-save-button" onClick={handleSave}>
                                                        {btnLoader ? (
                                                            <img
                                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                                className="loading-icon"
                                                                alt="Loading"
                                                                id="businessprofile-loading-icon"
                                                            />
                                                        ) : null}
                                                        Update
                                                    </button>
                                                </div>

                                                <div className="col-md-6 businessprofile-col-divider" id="businessprofile-right-col" style={{ alignSelf: 'flex-start' }}>
                                                    {/* .bank-highlight-zone / .is-highlighted live in index.css - see there
                                                        for the pulse. */}
                                                    <div
                                                        className={`input_group_wrapper bank-highlight-zone${highlightBank ? " is-highlighted" : ""}`}
                                                        id="businessprofile-bank-wrapper"
                                                        ref={bankSectionRef}
                                                        // The ring takes the colour of whatever it is wrapping - purple against
                                                        // the connected panel, amber against the action-required card.
                                                        style={hasBankAccount ? undefined : { '--bank-ring': '#E9A23B', '--bank-ring-glow': 'rgba(233, 162, 59, 0.45)' }}
                                                    >
                                                        {/* With no account connected the action card below is the whole
                                                            story - a section label and a line about where payouts go would
                                                            just say it twice, more quietly. */}
                                                        {(bankStatusLoading || hasBankAccount) && (<>
                                                            <label className="form_label" id="businessprofile-bank-label">
                                                                BANK ACCOUNT
                                                            </label>
                                                            <p className="mb-3" id="businessprofile-bank-subtext" style={{ fontSize: '13px', color: 'var(--SemiBlackText)' }}>
                                                                Payouts from card and QR sales are sent to this account.
                                                            </p>
                                                        </>)}

                                                        {bankStatusLoading ? (
                                                            <div className="card" id="businessprofile-bank-loading-card" style={{ borderRadius: 0, boxShadow: 'none' }}>
                                                                <div className="card-body bank-details" id="businessprofile-bank-loading-body">
                                                                    <p className="discription-text mb-0" id="businessprofile-bank-loading">
                                                                        Checking bank account status...
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        ) : hasBankAccount ? (
                                                            <div className="card" id="businessprofile-bank-connected-card" style={{ borderRadius: 0, boxShadow: 'none' }}>
                                                                <div className="card-body bank-details" id="businessprofile-bank-connected-body">
                                                                    <div className="d-flex align-items-center mb-2" id="businessprofile-bank-connected-header">
                                                                        <span
                                                                            className="material-icons"
                                                                            style={{ color: bankStatus?.status === "RESTRICTED" ? '#dc3545' : '#28a745', marginRight: '8px' }}
                                                                        >
                                                                            {bankStatus?.status === "RESTRICTED" ? "error" : "check_circle"}
                                                                        </span>
                                                                        <span id="businessprofile-bank-connected-title">
                                                                            {bankStatus?.status === "RESTRICTED"
                                                                                ? (paidPaused ? "Paid Bookings Paused" : "Payouts Paused")
                                                                                : bankStatus?.payoutsEnabled ? "Bank Account Connected" : "Bank Account Added"}
                                                                        </span>
                                                                    </div>
                                                                    <div id="businessprofile-bank-details">
                                                                        {bankStatus.bankName && (
                                                                            <p className="mb-1" id="businessprofile-bank-name">
                                                                                <strong>Bank Name:</strong> {bankStatus.bankName}
                                                                            </p>
                                                                        )}
                                                                        {bankStatus.bankLast4 && (
                                                                            <p className="mb-1" id="businessprofile-bank-last4">
                                                                                <strong>Account:</strong> **** {bankStatus.bankLast4}
                                                                            </p>
                                                                        )}
                                                                        {bankStatus.bankAccountHolderType && (
                                                                            <p className="mb-1" id="businessprofile-bank-holder-type">
                                                                                <strong>Account Type:</strong> {formatStatusLabel(bankStatus.bankAccountHolderType)}
                                                                            </p>
                                                                        )}
                                                                        {bankStatus.bankStatus && (
                                                                            <p className="mb-1" id="businessprofile-bank-status">
                                                                                <strong>Status:</strong> {formatStatusLabel(bankStatus.bankStatus)}
                                                                            </p>
                                                                        )}
                                                                        {!bankStatus?.payoutsEnabled && bankStatus?.status !== "RESTRICTED" && (
                                                                            <p className="mt-2" id="businessprofile-bank-pending-note">
                                                                                <small>Stripe is still verifying this account. Payouts will start once verification is complete.</small>
                                                                            </p>
                                                                        )}
                                                                        {bankStatus?.status === "RESTRICTED" && (
                                                                            <div className="mt-2" id="businessprofile-bank-restricted-note">
                                                                                <p className="mb-1" style={{ color: '#dc3545' }}>
                                                                                    <small>
                                                                                        {paidPaused
                                                                                            ? "Stripe has paused transfers to this account, so your paid plans are hidden from the SpotSaver app until it's resolved."
                                                                                            : bankStatus?.disabledReason
                                                                                            ? `Stripe paused payouts — ${formatRequirement(bankStatus.disabledReason)}.`
                                                                                            : "Stripe has paused payouts on this account."}
                                                                                    </small>
                                                                                </p>
                                                                                {dueLabels.length > 0 && (
                                                                                    <ul className="mb-0" style={{ paddingLeft: '18px' }}>
                                                                                        {dueLabels.map((label) => (
                                                                                            <li key={label}><small>{label}</small></li>
                                                                                        ))}
                                                                                    </ul>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                        {upcomingLabels.length > 0 && (
                                                                            <div
                                                                                className="mt-2"
                                                                                id="businessprofile-bank-upcoming-note"
                                                                                style={{ background: '#fefce8', border: '1px solid #facc15', borderRadius: 8, padding: '10px 12px' }}
                                                                            >
                                                                                <p className="mb-1" style={{ color: '#854d0e' }}>
                                                                                    <small>
                                                                                        <strong>Action recommended:</strong> Stripe will need a little more information
                                                                                        before your payouts can continue past its verification threshold. Providing it
                                                                                        now takes a minute and avoids an interruption later.
                                                                                    </small>
                                                                                </p>
                                                                                <ul className="mb-0" style={{ paddingLeft: '18px', color: '#854d0e' }}>
                                                                                    {upcomingLabels.map((label) => (
                                                                                        <li key={label}><small>{label}</small></li>
                                                                                    ))}
                                                                                </ul>
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {/* A disabled primary button reads as broken, not "done" - once a
                                                                        bank account is on file there's no action left to take here, so
                                                                        this is a status pill, not a CTA. */}
                                                                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px', borderTop: '1px solid #e5e7eb', marginTop: '14px', paddingTop: '14px' }}>
                                                                        <span
                                                                            id="businessprofile-connect-bank-button"
                                                                            style={{
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                gap: '6px',
                                                                                padding: '8.7px 20px',
                                                                                borderRadius: 10,
                                                                                fontSize: '12px',
                                                                                fontWeight: 600,
                                                                                letterSpacing: '0.4px',
                                                                                // textTransform: 'uppercase',
                                                                                color: '#1e7e34',
                                                                                border: '1px solid #1e7e34',
                                                                                background: '#f0fdf4'
                                                                            }}
                                                                        >
                                                                            <span className="material-icons" style={{ fontSize: '16px', }}>check_circle</span>
                                                                            Connected
                                                                        </span>

                                                                        {/* Existing bank account - managed from here on via Stripe's own
                                                                            Express Dashboard (replace bank, view payout schedule, etc.),
                                                                            not our onboarding flow. */}
                                                                        <button
                                                                            type="button"
                                                                            className="outline_btn"
                                                                            id="businessprofile-update-bank-button"
                                                                            onClick={handleUpdateBank}
                                                                            disabled={bankLoginLoading}
                                                                            style={{ textTransform: 'capitalize', float: 'none', borderRadius: 10, letterSpacing: '0.4px' }}
                                                                        >
                                                                            {bankLoginLoading ? "Opening Stripe..." : "Update Bank Account"}
                                                                        </button>

                                                                        {/* Outstanding requirements (paused now, or due later) are collected by
                                                                            Stripe's hosted onboarding - the same flow they connected with - which
                                                                            asks only for what's still missing and returns them here. Preferred
                                                                            over the Express dashboard for this because it lands directly on the
                                                                            missing fields instead of a dashboard they have to search. */}
                                                                        {(bankRestricted || upcomingLabels.length > 0) && (
                                                                            <button
                                                                                type="button"
                                                                                className="fill-btn"
                                                                                id="businessprofile-provide-info-button"
                                                                                onClick={handleConnectBank}
                                                                                disabled={bankConnectLoading}
                                                                                style={{
                                                                                    textTransform: 'capitalize',
                                                                                    float: 'none',
                                                                                    borderRadius: 10,
                                                                                    letterSpacing: '0.4px',
                                                                                    background: bankRestricted ? '#dc2626' : '#ca8a04',
                                                                                    borderColor: bankRestricted ? '#dc2626' : '#ca8a04'
                                                                                }}
                                                                            >
                                                                                {bankConnectLoading ? "Redirecting to Stripe..." : "Provide Information on Stripe"}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            /* No account yet - money is actually being held, so this reads as a
                                                               standing task with a consequence, not a neutral empty state.
                                                               Styles live in index.css under .bank-action-card. */
                                                            <div className="bank-action-card" id="businessprofile-bank-connect-card">
                                                                <div className="bank-action-card__head" id="businessprofile-bank-action-head">
                                                                    <span className="bank-action-card__icon" aria-hidden="true">
                                                                        <span className="material-icons">priority_high</span>
                                                                    </span>
                                                                    <span className="bank-action-card__eyebrow" id="businessprofile-bank-action-eyebrow">
                                                                        Action Required
                                                                    </span>
                                                                </div>

                                                                <h5 className="bank-action-card__title" id="businessprofile-bank-action-title">
                                                                    Connect a bank account to get paid
                                                                </h5>
                                                                <p className="bank-action-card__text" id="businessprofile-bank-not-connected">
                                                                    Payouts from card and QR sales are held until an account is connected. Takes about two minutes.
                                                                </p>

                                                                <div className="bank-action-card__actions" id="businessprofile-bank-action-buttons">
                                                                    <button
                                                                        className="fill-btn"
                                                                        id="businessprofile-connect-bank-button"
                                                                        onClick={handleConnectBank}
                                                                        disabled={bankStatusLoading || bankConnectLoading}
                                                                        style={{ float: 'none', borderRadius: 10, letterSpacing: '0.4px' }}
                                                                    >
                                                                        {bankConnectLoading ? "Redirecting to Stripe..." : "Connect Bank Account"}
                                                                    </button>

                                                                    {/* Answered in place rather than on another page - the question is
                                                                        "should I hand over my bank details?", and leaving the card to
                                                                        find out is how clients drop out of this. */}
                                                                    <button
                                                                        type="button"
                                                                        className="bank-action-card__why"
                                                                        id="businessprofile-bank-why-toggle"
                                                                        onClick={() => setShowBankWhy((prev) => !prev)}
                                                                        aria-expanded={showBankWhy}
                                                                        aria-controls="businessprofile-bank-why-text"
                                                                    >
                                                                        {showBankWhy ? "Hide details" : "Why we need this"}
                                                                    </button>
                                                                </div>

                                                                {showBankWhy && (
                                                                    <p className="bank-action-card__why-text" id="businessprofile-bank-why-text">
                                                                        Card and QR payments are processed by Stripe, and Stripe only releases
                                                                        money to a verified bank account. Setup happens on Stripe's own pages -
                                                                        have your bank routing and account numbers to hand, along with your EIN
                                                                        or SSN and a photo ID.
                                                                    </p>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Business Profile End here */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <SweetAlert
                            show={tableErrMsg}
                            custom
                            confirmBtnText="ok"
                            confirmBtnBsStyle="primary"
                            title={"Something went wrong. Please reload again."}
                            onConfirm={(e) => setTableErrMsg(false)}
                            id="businessprofile-alert-error"
                        />

                        <Footer id="businessprofile-footer" />

                        <ToastContainer
                            position="bottom-center"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover={false}
                            theme="light"
                            id="businessprofile-toast-container"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default BusinessProfile;
